import React, { useContext, useState, MouseEvent, KeyboardEvent, FC, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from 'styled-components';
import { keySession } from "../../services/axios";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import logo from '../../assets/logoD.png';
import Logout from '@mui/icons-material/Logout';

interface Props {
  toggleTheme(): void
}

const Header: FC<Props> = ({ toggleTheme }) => {
  const { colors } = useContext(ThemeContext);
  const [state, setState] = useState(false);
  const [openCollapse1, setOpenCollapse1] = useState(false);
  const [openCollapse2, setOpenCollapse2] = useState(false);

  const toggleDrawer =
    (open: boolean) =>
      (event: KeyboardEvent | MouseEvent) => {
        if (
          event &&
          event.type === 'keydown' &&
          ((event as KeyboardEvent).key === 'Tab' ||
            (event as KeyboardEvent).key === 'Shift')
        ) {
          return;
        }
        setState(open);
      };

  const handleOpenSettings1 = () => {
    setOpenCollapse1(!openCollapse1);
    setOpenCollapse2(false);
  }
  const handleOpenSettings2 = () => {
    setOpenCollapse2(!openCollapse2);
    setOpenCollapse1(false);
  }

   const logout = () => {
    localStorage.removeItem(keySession)
    window.location.replace('/login');
  }

  const list = () => (
    <Box role="presentation" onKeyDown={toggleDrawer(false)} >
      <Toolbar sx={{ bgcolor: colors.c02 }}>
        <img alt="" src={logo} />
      </Toolbar>
      <List>
        <ListItem onClick={handleOpenSettings1}>
          <ListItemIcon sx={{ color: colors.c04 }}><AdminPanelSettingsIcon /></ListItemIcon>
          <ListItemText sx={{ color: colors.c04 }} primary="Cadastro" />
          {openCollapse1 ? <ExpandLess sx={{ cursor: "pointer" }}/> : <ExpandMore sx={{ cursor: "pointer" }}/>}
        </ListItem>
        <Collapse in={openCollapse1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem key="Feriado" component={Link} to="Feriado" onClick={toggleDrawer(false)}>
              <ListItemText sx={{ color: colors.c04, fontSize: '15px', cursor: 'pointer' }} primary="Feriado" />
            </ListItem>
            <ListItem key="Person" component={Link} to="Person" onClick={toggleDrawer(false)}>
              <ListItemText sx={{ color: colors.c04, fontSize: '15px', cursor: 'pointer' }} primary="Colaborador" />
            </ListItem>
          </List> 
        </Collapse> 
      </List>
      <List>
        <ListItem onClick={handleOpenSettings2}>
          <ListItemIcon sx={{ color: colors.c04 }}><AdminPanelSettingsIcon /></ListItemIcon>
          <ListItemText sx={{ color: colors.c04 }} primary="Relatório" />
          {openCollapse2 ? <ExpandLess sx={{ cursor: "pointer" }} /> : <ExpandMore sx={{ cursor: "pointer" }} />}
        </ListItem>
        <Collapse in={openCollapse2} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            <ListItem key="Dimep" component={Link} to="Dimep" onClick={toggleDrawer(false)}>
              <ListItemText sx={{ color: colors.c04, fontSize: '15px', cursor: 'pointer' }} primary="DIMEP" />
            </ListItem>
          </List> 
          <List component="div" disablePadding>
            <ListItem key="PontoTxt" component={Link} to="PontoTxt" onClick={toggleDrawer(false)}>
              <ListItemText sx={{ color: colors.c04, fontSize: '15px', cursor: 'pointer' }} primary="Ponto TXT" />
            </ListItem>
          </List> 
        </Collapse> 
      </List>
      <List>
        <ListItem onClick={() => logout()} sx={{ cursor: "pointer" }}>
          <ListItemIcon sx={{ color: colors.c04 }}><Logout /></ListItemIcon>
          <ListItemText sx={{ color: colors.c04 }} primary="Sair" />
        </ListItem>
      </List>
    </Box >
  );

  return (
    <Box sx={{ flexGrow: 1, scrollbarWidth: 0 }}>
      <AppBar position="absolute" sx={{ bgcolor: colors.c02, width: "100%" }}>
        <Toolbar>
            <Fragment key={'left'}>
              <Button onClick={toggleDrawer(true)} >
                <IconButton
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="menu"
                  sx={{ mr: 2, color: colors.c05 }}
                >
                  <MenuIcon />
                </IconButton>
              </Button>
              <SwipeableDrawer
                PaperProps={{ sx: { backgroundColor: colors.c01, color: colors.c04 } }}
                anchor={'left'}
                open={state}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
              >
                {list()}
              </SwipeableDrawer>
            </Fragment>
          <img alt="" src={logo} />
        </Toolbar>
      </AppBar>
    </Box >
  );
}

export default Header;
